var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShiftKeyLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(8 8)",
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 22H13.4999C13.2348 21.9997 12.9806 21.8942 12.7931 21.7068C12.6057 21.5193 12.5002 21.2651 12.4999 21V16H9.99989C9.90102 16 9.80437 15.9706 9.72216 15.9157C9.63996 15.8607 9.57589 15.7827 9.53805 15.6913C9.50022 15.6 9.49032 15.4994 9.5096 15.4025C9.52889 15.3055 9.57649 15.2164 9.64639 15.1465L15.6464 9.14649C15.6928 9.10004 15.7479 9.06319 15.8086 9.03805C15.8692 9.01291 15.9342 8.99997 15.9999 8.99997C16.0656 8.99997 16.1306 9.01291 16.1912 9.03805C16.2519 9.06319 16.307 9.10004 16.3534 9.14649L22.3534 15.1465C22.4233 15.2164 22.4709 15.3055 22.4902 15.4025C22.5095 15.4994 22.4996 15.6 22.4617 15.6913C22.4239 15.7827 22.3598 15.8607 22.2776 15.9157C22.1954 15.9706 22.0988 16 21.9999 16H19.4999V21C19.4995 21.2651 19.3941 21.5192 19.2066 21.7067C19.0191 21.8942 18.765 21.9996 18.4999 22ZM11.2069 15H13.4999V21H18.4999V15H20.7928L15.9999 10.207L11.2069 15Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftKeyLegend);
export default __webpack_public_path__ + "static/media/shiftKeyLegend.513fb3ba07079161687b26f13fb3a7e2.svg";
export { ForwardRef as ReactComponent };